"use strict";
'app public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
var _AwayStatusIndicator = _interopRequireDefault(require("./AwayStatusIndicator"));
var _TypingStatusIndicator = _interopRequireDefault(require("./TypingStatusIndicator"));
var _UserAvatar = _interopRequireDefault(require("./UserAvatar"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = exports.default = {
  components: {
    AwayStatusIndicator: _AwayStatusIndicator.default,
    TypingStatusIndicator: _TypingStatusIndicator.default,
    UserAvatar: _UserAvatar.default
  },
  props: ['network', 'user', 'nicklist'],
  computed: {
    dataAttributes() {
      const attrs = Object.create(null);
      attrs['data-nick'] = this.user.nick.toLowerCase();
      if (this.user.account) {
        attrs['data-account'] = this.user.account.toLowerCase();
      }
      const userMode = this.nicklist.buffer.userMode(this.user);
      if (userMode) {
        attrs['data-mode'] = userMode;
      }
      return attrs;
    },
    userColour() {
      return '#ffffff';
    },
    isSelf() {
      return !!(this.network && this.user && this.network.nick && this.user.nick.toLowerCase() === this.network.nick.toLowerCase());
    },
    userModePrefix() {
      return this.nicklist.buffer.userModePrefix(this.user);
    },
    modeBadge() {
      const mode = this.nicklist.buffer.userMode(this.user);
      const map = {
        q: {
          label: 'LEADER',
          key: 'owner'
        },
        a: {
          label: 'ADMIN',
          key: 'admin'
        },
        o: {
          label: 'STAFF',
          key: 'op'
        },
        h: {
          label: 'MODO',
          key: 'halfop'
        },
        v: {
          label: 'VIP',
          key: 'voice'
        }
      };
      return map[mode] || null;
    },
    userTypingState() {
      const status = this.user.typingStatus(this.nicklist.buffer.name).status;
      // console.log('userTypingState', this.user.nick, status);
      return status;
    },
    aslAge() {
      return this.user.asl && this.user.asl.a ? `${this.user.asl.a} ans` : '';
    },
    aslSexKey() {
      return this.user.asl && this.user.asl.s ? this.user.asl.s : '';
    },
    aslSexLabel() {
      if (!this.aslSexKey) {
        return '';
      }
      const labels = {
        _male: 'Homme',
        _female: 'Femme',
        _homme: 'Homme',
        _fehomme: 'Femme'
      };
      return labels[this.aslSexKey] || this.aslSexKey.replace(/^_/, '');
    },
    aslSexClass() {
      const sex = (this.aslSexKey || '').toLowerCase();
      // NB : « femme » ne contient pas « female » ni « male », d'où le test explicite.
      // Le test femelle passe avant le mâle (« fehomme » contient « homme »).
      if (sex.includes('female') || sex.includes('femme') || sex.includes('fehomme')) {
        return 'female';
      }
      if (sex.includes('male') || sex.includes('homme')) {
        return 'male';
      }
      return 'other';
    },
    aslLocation() {
      return this.user.asl && this.user.asl.l ? this.user.asl.l : '';
    },
    isServiceBot() {
      // Bots de service reconnus par leur host (secu/clara/eva) OU par leur
      // pseudo (Chaat / Partners / Robot) : pseudo affiché « Robot », avatar
      // robot, sous-titre « Service des salons », et jamais de modal profil.
      return Misc.isServiceBot(this.user);
    },
    displayNick() {
      return this.isServiceBot ? 'Robot' : this.user.nick;
    },
    specialSubtitle() {
      return this.isServiceBot ? 'Service des salons' : '';
    },
    aslMetaLine() {
      return this.aslAge || this.aslSexLabel || this.aslLocation;
    }
  }
};
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
window._app_exports["components"]["NicklistUser"]
window._app_exports.components.NicklistUser = exports.default ? exports.default : exports;
